import { QueryKey } from '../../constants/index';
import { HttpException } from '../../exceptions/index';
import { useScenarioStore } from '../../pages/scenario-modeling/scenario-modeling.store';
import { scenarioSocketStore } from '../../sockets/scenarios.util';
import { useAppMutation } from '../use-app-mutation.hook';
import { useInvalidateQueries } from '../use-invalidate-queries.hook';

type WsErrorBody = {
  error?: string;
  message?: string;
  statusCode?: number;
};

type CalcCapTableWsPayload = {
  error?: WsErrorBody;
  ok: boolean;
};
export const useCalcCapTable = () => {
  const { invalidateQuery } = useInvalidateQueries(
    QueryKey.CAP_TABLE_STAKEHOLDERS,
    QueryKey.CAP_TABLE_STAKEHOLDER_TYPES,
    QueryKey.CAP_TABLE_STAKEHOLDER_BY_ALL,
    QueryKey.CAP_TABLE_SHARE_CLASSES,
    QueryKey.CAP_TABLE_SUMMARIZE,
  );

  const scenariosSocket = scenarioSocketStore().getSocket();
  const setActionStateBlocked = useScenarioStore(
    ({ setActionStateBlocked }) => setActionStateBlocked,
  );
  const {
    mutate: calcCapTable,
    isPending,
    status,
    error,
  } = useAppMutation([QueryKey.CALC_CAP_TABLE], {
    mutationFn: ({ scenarioId }: { scenarioId: string }) =>
      new Promise<void>((resolve, reject) => {
        const timer = setTimeout(() => {
          console.log('timeout from frontend for ws connection');
          reject(new Error(`Request timed out after ${120_000 / 1000}s`));
        }, 120_000);

        setActionStateBlocked(true);
        scenariosSocket.emit('calc-cap-table', { scenarioId }, (payload: CalcCapTableWsPayload) => {
          clearTimeout(timer);
          if (!payload?.ok) {
            const status = payload.error?.statusCode ?? 400;
            const statusText = payload.error?.error ?? 'Bad Request';
            const message = payload.error?.message || 'Request failed';

            reject(new HttpException(new Response(null, { status, statusText }), { message }));
            return;
          }
          resolve();
        });
      }),

    onSettled: () => {
      setActionStateBlocked(false);
    },
    onSuccess: () => invalidateQuery(),
  });

  return { calcCapTable, isPending, status, error };
};
